import services from './services.js';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';

//组件
import complexSearch from '@pages/CRMAgentManage/components/complex-search/index.vue';

// import crmFormAgentDetails from '@pages/CRMFormatAgent/crm-form-agent-details.vue';
import viewDialog from '@pages/CRMAgentManage/CRMFormatAgent/components/viewDialog/index.vue'; //查看弹窗
import editDialog from '@pages/CRMAgentManage/CRMFormatAgent/components/edit-dialog/index.vue';
import agentarea from '@pages/CRMAgentManage/CRMFormatAgent/components/agentArea/index.vue';

export default {
    mixins: [services],
    components: {
        // 'crm-form-agent-details': crmFormAgentDetails,
        'complex-search': complexSearch,
        'edit-dialog': editDialog,
        'agent-area': agentarea,
        viewDialog
    },
    created() {
        this.getList();
        if (this.$route.path == '/crmAgent/searchFormatAgent') {
            this.complexSearchShow = false;
        } else {
            this.complexSearchShow = true;
        }
    },
    data() {
        return {
            /* 主表数据 */
            complexSearchShow: true,
            loading: false,
            lists: [], //表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [], //列表选中
            currentId: null, //当前选中的行id
            /* 高级搜索 */
            searchVisiable: false,
            modifyDialogVisiable: false,
            editData: null,
            isReadOnlyLook: false,
            filterData: {},
            showarea: false, //显示代理区域
            agentId: "" //代理商ID
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        },
        arrowClass() {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle() {
            if (this.searchVisiable) {
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    watch: {
        '$route' (to, from) {
            this.filterData = {};
            this.$refs.complexSearch.reset();
            if (this.$route.path == '/crmAgent/searchFormatAgent') {
                this.pageIndex = 1;
                this.totalSize = 1;
                this.complexSearchShow = false;
                setTimeout(() => {
                    this.getList();
                }, 500);
            } else {
                this.complexSearchShow = true;
            }
        }
    },
    methods: {
        viewAgentArea(row) {
            this.agentId = row.Id;
            let isReadOnly = false;
            if (this.$route.path == '/crmAgent/formatAgent') {
                isReadOnly = true;
            }
            lg(isReadOnly);
            this.$refs.refAgentArea.show({
                isReadOnly: isReadOnly,
                AgentId: this.agentId
            });
        },
        clearIMEI(row) {
            this.$confirm('清除IMEI, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.clearIMEIService(row.Id);
            }).catch(() => {});
        },
        updateFn(row) {
            this.getAgent(row.CustomerId);
        },
        selectRow(row) {
            if (!row) return;
            this.currentId = row.Id;
            this.currentStatus = row.Agent_Status;
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        toggleSearch() {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch(data) {
            this.filterData = data;
            this.getList();
        },
        resetFilterData() {
            this.filterData = {};
            this.getList();
        },
        agentPoorReceive() {
            if (this.currentId === null) {
                this.$notify({
                    title: '警告',
                    message: '请先选择要接收的客户',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认要接收该客户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.req_AgentPoorReceive({
                    Id: this.currentId
                });
            }).catch(() => {});
        },
        showDetails(row) {
            //util.redirect(this, `/acountManage/formatAgent/details?Id=${row.Id}`, false);
            // this.$refs.crmFormAgentDetails.showDialog(row.Id);
            this.$refs.viewDialog.show({
                Id: row.CustomerId,
                title: '查看',
            })
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/ViewCRMFormatAgent/vm.js